import React, { useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router";
import MasterPage from "../../layouts/MasterPage";
import { Link } from "react-router-dom";
import authAPI from "../../api/authAPI";
import AuthenticationManager from "../../services/StorageJWT";
import gameAPI from "../../api/gameAPI";
import profileAPI from "../../api/profileAPI";

const Games = () => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const _auth = new AuthenticationManager();
  useEffect(() => {
    profileAPI
      .games(_auth._token)
      .then((res) => {
        setGames(res);
        console.log(res);
      })
      .catch((e) => {});
  }, []);
  const setActiveGame = (gid) => {
    profileAPI
      .setActiveGame(_auth._token, gid)
      .then((res) => {
        // if (res.redirect == false) return;
        if (res.needCode) {
          navigate("/properties");
          return;
        }
        if (gid == 1) {
          navigate("/one", { replace: true });
          window.history.pushState(null, "", "/one");
          window.history.replaceState(null, "", "/one");
        } else {
          navigate("/two", { replace: true });
          window.history.pushState(null, "", "/two");
          window.history.replaceState(null, "", "/two");
        }
      })
      .catch((e) => {});
  };
  return (
    <MasterPage>
      <div className="structure-page structure-page-4 login p-3 body menu ">
        <div className="text-center w-100 mt-3 games">
          {games.map((game) => (
            <div
              className={`item mb-3`}
              role="button"
              onClick={() => setActiveGame(game.game_id)}
            >
              <svg
                className={`bg-game  ${
                  game.game_id == _auth?._user?.user?.active_game_id
                    ? "border border-dark p-4"
                    : "p-4"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 304 150"
                fill="none"
              >
                <path
                  d="M2.49609 10.7583C2.49609 6.34002 6.07782 2.7583 10.4961 2.7583H293.611C298.03 2.7583 301.611 6.34002 301.611 10.7583V139.815C301.611 144.234 298.03 147.815 293.611 147.815H10.4961C6.07782 147.815 2.49609 144.234 2.49609 139.815V10.7583Z"
                  fill="#EAE6DB"
                  stroke="#EAE6DB"
                  stroke-width="4"
                  stroke-linecap="round"
                  stroke-dasharray="4 4"
                />
              </svg>
              <div className="text">
                <h5>{game.game.name}</h5>
                <div className="d-flex">
                  <span> کد اختصاصی: </span>
                  <span>{game.code}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="d-grid gap-2 w-100">
          <button
            onClick={() => navigate("/menu/games/code")}
            className="btn btn-submit pt-2 pb-2 w-100"
          >
            ثبت کد جدید
          </button>
          <button
            onClick={() => navigate(-1)}
            className="btn btn-return pt-2 pb-2 w-100"
          >
            بازگشت
          </button>
        </div>
      </div>
    </MasterPage>
  );
};

export default Games;
